import React from 'react';
import { Button } from 'antd';
import { BookOpen, Play, Route } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import './StoryMode.css';

const StoryMode = () => {
  const navigate = useNavigate();

  const handleLaunchSparc = () => {
    navigate('/story/sparc');
  };

  const handleLaunchNewton = () => {
    navigate('/story/newton');
  };

  return (
    <section className="story-mode container">
      <div className="story-header">
        <div>
          <span className="story-pill">Story Mode</span>
          <h2>Guided Experiences</h2>
          <p>A curated path. Less browsing, more momentum.</p>
        </div>
      </div>

      <div className="story-list" aria-label="Story mode experiences">
        <div className="story-strip" role="group" aria-label="SPARC story experience">
          <div className="story-strip-left">
            <div className="story-icon" aria-hidden="true">
              <BookOpen size={20} />
            </div>
            <div>
              <h3>SPARC</h3>
              <p>Learning through play in the SPARC environment.</p>
            </div>
          </div>

          <div className="story-strip-right">
            <Button type="primary" onClick={handleLaunchSparc}>
              Open SPARC <Play size={16} />
            </Button>
          </div>
        </div>

        <div className="story-strip" role="group" aria-label="Newton four-game story experience">
          <div className="story-strip-left">
            <div className="story-icon" aria-hidden="true">
              <Route size={20} />
            </div>
            <div>
              <h3>Newton Physics Challenge</h3>
              <p>Play Newton's three laws and Force and Motion as one continuous sequence.</p>
            </div>
          </div>

          <div className="story-strip-right">
            <Button type="primary" onClick={handleLaunchNewton}>
              Open Newton <Play size={16} />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StoryMode;
